'use client';

import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { getCategoriesQuery, getRubricsQuery } from '@/features/articles';
import { Apps } from '@/components/Apps';
import FavoritesIcon from '@/shared/assets/favorites.svg?svg';
import LogoIcon from '@/shared/assets/logo.svg?svg';
import { NavLink, Text } from '@/shared/ui';
import styles from './Sidebar.module.css';

type SidebarProps = {
  withLogo?: boolean;
  className?: string;
};

export const Sidebar = ({ withLogo = true, className }: SidebarProps) => {
  const pathname = usePathname();
  const { data: categories = [] } = useQuery(getCategoriesQuery());
  const { data: rubrics = [] } = useQuery(getRubricsQuery());
  const sortedCategories = [...categories].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
  );
  const sortedRubrics = [...rubrics].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
  );

  return (
    <div className={clsx(styles.sidebar, className)}>
      {withLogo && (
        <Link href="/">
          <LogoIcon className={styles.logo} />
        </Link>
      )}
      <nav className={styles.links}>
        {sortedCategories?.map((category) => (
          <NavLink
            className={clsx(styles.link, styles.link__main)}
            href={`/category/${category.slug}`}
            key={category.slug}
            isActive={pathname === `/category/${category.slug}`}
          >
            {category.name}
          </NavLink>
        ))}
      </nav>
      <nav className={clsx(styles.rubrics)}>
        <Text className={styles.title} color="text-secondary" fontSize={13.5}>
          Темы
        </Text>
        <div className={clsx(styles.inner, 'scroll')}>
          {sortedRubrics?.map((rubric) => (
            <NavLink
              className={styles.link}
              href={`/rubric/${rubric.slug}`}
              key={rubric.slug}
            >
              {rubric.name}
            </NavLink>
          ))}
        </div>
      </nav>

      <div className={styles.bottom}>
        <NavLink
          className={styles.link}
          href="/favorites"
          icons={{
            inactive: (
              <FavoritesIcon
                style={{
                  width: '20px',
                }}
              />
            ),
          }}
        >
          Избранное
        </NavLink>
        <Apps />
      </div>
    </div>
  );
};
